/**
 * Layout-related constants for the application
 */

export const LAYOUT_CONSTANTS = {
  /**
   * Routes that should be considered as admin routes
   */
  ADMIN_ROUTES: [
    'admin-home',
    'admin-add-edit-premix',
    'admin-add-edit-technical-guide',
  ] as const,

  /**
   * Routes where tabs should be hidden
   */
  HIDE_TABS_ROUTES: [
    'admin-add-edit-premix',
    'admin-add-edit-technical-guide',
  ] as const,

  /**
   * Service flags used for calculator tab management
   */
  SERVICE_FLAGS: [
    'premixShow',
    'jarmixShow',
    'atsShow',
    'techGuideShow',
    'programBuilderShow',
    'resistanceShow'
  ] as const,

  /**
   * Admin page titles
   */
  ADMIN_TITLES: {
    PREMIX: 'PREMIX CALCULATOR ADMIN',
    TECHNICAL: 'TECHNICAL GUIDES ADMIN',
    RESISTANCE: 'RESISTANCE MANAGEMENT ADMIN'
  } as const,

  /**
   * Regular page titles
   */
  CALCULATOR_TITLES: {
    PREMIX: 'PREMIX CALCULATOR',
    JARMIX: 'JAR MIX CALCULATOR',
    ATS: 'ATS CALCULATOR',
    TECHNICAL: 'TECHNICAL GUIDES',
    PROGRAM_BUILDER: 'PROGRAM BUILDER',
    RESISTANCE: 'RESISTANCE MANAGEMENT'
  } as const,

  /**
   * Dropdown labels for mobile navigation
   */
  DROPDOWN_LABELS: {
    PREMIX: 'Premix calculator',
    JARMIX: 'Jar test calculator',
    ATS: 'ATS calculator',
    TECHNICAL: 'Technical Guides',
    PROGRAM_BUILDER: 'Program Builder',
    RESISTANCE_MANAGEMENT: 'Resistance Management',
    ADMIN_PREMIX: 'Admin Premix',
    ADMIN_TECHNICAL: 'Admin Technical Guides',
    ADMIN_RESISTANCE_MANAGEMENT: 'Admin Resistance Management'
  } as const
} as const;

// Export individual constants for easier importing
export const {
  ADMIN_ROUTES,
  HIDE_TABS_ROUTES,
  SERVICE_FLAGS,
  ADMIN_TITLES,
  CALCULATOR_TITLES,
  DROPDOWN_LABELS
} = LAYOUT_CONSTANTS;
